import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import DatePicker from '../../../components/DatePicker';
import moment from 'moment';

const DobFilter = ({
  updateQuery,
  dob,
  setDob,
}) => {
  const dateFormat = ['MM/DD/YYYY', 'MM-DD-YYYY', 'MMDDYYYY', 'YYYY-MM-DD'];

  const handleDobChange = (date) => {
    const formattedDate = date ? date.format('YYYY-MM-DD') : null;
    setDob(formattedDate);
    updateQuery({ dob: formattedDate });
  };

  return (
    <div className="dob-filter">
      <DatePicker
        className="dob-filter-date-picker"
        placeholder="DOB"
        value={dob ? moment(dob, 'YYYY-MM-DD') : null}
        onChange={handleDobChange}
        style={{ borderRadius: '8px' }}
        format={dateFormat}
      />
    </div>
  );
};

DobFilter.defaultProps = {
  updateQuery: () => {},
  dob: null,
  setDob: () => {},
};

DobFilter.propTypes = {
  updateQuery: PropTypes.func,
  dob: PropTypes.string,
  setDob: PropTypes.func,
};

export default withRouter(DobFilter);
